import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/globals.css';

/* Apply persisted or system-preferred theme / density / font-family early,
 * before paint, to avoid a flash of the default theme on navigation. */
(() => {
  try {
    // 1. Explicit user choice wins.
    const saved = JSON.parse(localStorage.getItem('lab.theme') || 'null')?.state?.theme;
    if (saved) {
      document.documentElement.setAttribute('data-theme', saved);
    } else if (window.matchMedia) {
      // 2. Otherwise fall back to the OS preference.
      const prefersLight = window.matchMedia('(prefers-color-scheme: light)').matches;
      if (prefersLight) {
        document.documentElement.setAttribute('data-theme', 'parchemin');
      }
      // Dark (default) leaves `graphite` from index.html <html data-theme>.
    }

    const density = JSON.parse(localStorage.getItem('lab.density') || 'null')?.state?.density;
    if (density && density !== 'comfortable') {
      document.documentElement.setAttribute('data-density', density);
    }

    const font = JSON.parse(localStorage.getItem('lab.fontfamily') || 'null')?.state?.fontFamily;
    if (font && font !== 'geist') {
      document.documentElement.setAttribute('data-fontfamily', font);
    }

    const sidebar = JSON.parse(localStorage.getItem('lab.sidebar') || 'null')?.state?.collapsed;
    if (sidebar) {
      document.documentElement.setAttribute('data-sidebar', 'collapsed');
    }
  } catch { /* ignore — defaults will apply */ }
})();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
